import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { DropDownSelector, RangeBox } from '@lk-gtcom/ecomlab-components';
import {
  fetchAdvCampaignFilter,
  fetchOrderSuperStatusFilter,
  fetchAdvCampaignTypeFilter,
  fetchAdvStatusFilter,
  fetchApiFilterVer3,
  fetchCostFilter,
  fetchApiFilterSummary,
  fetchApiFilterLens
} from '../../common/filtersFunc';
import { AnalyticsPageComponent } from '../AnalyticsPageComponent/AnalyticsPageComponents';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import routes from './routes';
import useGeneralStore from '../../store/general';
// Отмена запросов для фильтров
import { RequestController } from '../../common/filtersFunc';
import { periodWeek } from '../../common/constant';
import { options_prop_mp } from '../../common/globalVariables';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const pageFiltersMap = {
  [routes.analytics]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    campaign: true,
    warehouse: true,
    checkbox: true
  },
  [routes.marginality_analysis]: {
    mp: true,
    api: true,
    // category: true,
    // brand: true,
    // superStatus: true,
    margin: true
  },
  [routes.advertising]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    campaign: true,
    advCampaign: true,
    advCampaignType: true,
    advStatus: true
  },
  [routes.ordersAndSales]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    // campaign: true,
    warehouse: true,
    superStatus: true
  },
  [routes.returnAndCancellations]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    campaign: true,
    warehouse: true,
  },
  [routes.prices]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    // campaign: true,
    // warehouse: true,
  },
  [routes.stock]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    // campaign: true,
    // warehouse: true,
    fbs_fbm: true
  },
  [routes.abc]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
  },
  [routes.lowHigh]: {
    mp: true,
    api: true,
    category: true,
    brand: true,
    summary: true
  },
  [routes.brand_report]: {
    mp: true,
    api: true,
    category: true,
    brand2: true,
  },
  [routes.slices]: {
    mp: true,
    api: true,
    category: true,
    brand2: true,
  },
};

const pageTabsMap = {
  [routes.analytics]: [
    {
      label: 'По датам',
      value: 'date',
    },
    {
      label: 'По товарам',
      value: 'product',
    },
    {
      label: 'По категориям',
      value: 'category',
    },
    {
      label: 'По брендам',
      value: 'brand',
    },
    {
      label: 'По складу',
      value: 'warehouse',
    },
    {
      label: 'По компаниям',
      value: 'campaign',
    },
  ],
  [routes.marginality_analysis]: [
    {
      label: 'По датам',
      value: 'sebes_by_dates',
    },
    {
      label: 'По товарам',
      value: 'sebes_by_products',
    },
    {
      label: 'По категориям',
      value: 'sebes_by_cats',
    },
    {
      label: 'По брендам',
      value: 'sebes_by_brands',
    },
    // {
    //   label: 'По складу',
    //   value: 'warehouse',
    // },
    // {
    //   label: 'По компаниям',
    //   value: 'campaign',
    // },
  ],
  [routes.advertising]: [
    {
      label: 'По датам',
      value: 'date',
    },
    {
      label: 'По товарам',
      value: 'product',
    },
    {
      label: 'По категориям',
      value: 'category',
    },
    {
      label: 'По брендам',
      value: 'brand',
    },
    {
      label: 'По рекламным кампаниям',
      value: 'campaign',
    },
    {
      label: 'По типу рекламной кампании',
      value: 'campaign_type',
    },
    {
      label: 'По упущенным продажам',
      value: 'missed_sales',
    },
  ],
  [routes.ordersAndSales]: [
    {
      label: 'Список заказов',
      value: 'orders_list',
    },
    {
      label: 'По складам',
      value: 'orders_list_by_wh',
    },
    {
      label: 'По типу поставки',
      value: 'orders_list_by_ff_type',
    },
    {
      label: 'По региону',
      value: 'orders_list_by_region',
    },
    {
      label: 'Заказы по статусам',
      value: 'orders_list_by_status',
    },
  ],
  [routes.returnAndCancellations]: [
    {
      label: 'Отмененные и возвращенные заказы',
      value: 'list',
    },
    {
      label: 'По причинам',
      value: 'reason',
    },
    {
      label: 'По товарам',
      value: 'product',
    },
    {
      label: 'По категориям',
      value: 'category',
    },
    {
      label: 'По брендам',
      value: 'brand',
    },
    // {
    //     label: 'По возвратам',
    //     value: 'returns'
    // },
  ],
  [routes.prices]: [
    // {
    //   label: 'Цены в динамике',
    //   value: 'prices_in_dynamics',
    // },
    // {
    //     label: 'По актуальным ценам',
    //     value: 'actual_prices'
    // },
    // {
    //   label: 'Цены',
    //   value: 'prices',
    // },
    {
      label: 'Цены',
      value: 'price_by_products',
    },
    {
      label: 'По дням',
      value: 'price_by_days',
    },
    // {
    //     label: 'По товарам',
    //     value: 'product',
    // },
    // {
    //     label: 'По площадкам',
    //     value: 'marketplace'
    // },
    // {
    //     label: 'По конкурентам',
    //     value: 'competitors'
    // },
    // {
    //     label: 'По эластичности',
    //     value: 'elasrtic'
    // },
    // {
    //     label: 'По себестоимости',
    //     value: 'net'
    // },
  ],
  [routes.stock]: [
    {
      label: 'По датам',
      value: 'stock_by_days',
    },
    {
      label: 'По товарам',
      value: 'stock_by_products',
    },
    // {
    //   label: 'По дате и складам',
    //   value: 'date_and_wh',
    // },
    {
      label: 'По категориям',
      value: 'stock_by_category',
    },
    {
      label: 'По брендам',
      value: 'stock_by_brands',
    },
    {
      label: 'Остатки в динамике',
      value: 'stock_by_dynamics_days',
    },
    //  {
    //   label: 'По дням',
    //   value: 'stock_by_days',
    // },
    // {
    //   label: 'По товарам 2.0',
    //   value: 'stock_by_products',
    // },
    // {
    //   label: 'По ABC',
    //   value: 'abc',
    // },
  ],
  [routes.abc]: [
    {
      label: 'По товарам',
      value: 'ABC_by_products',
    },
    {
      label: 'По категориям',
      value: 'ABC_by_cat',
    },
    {
      label: 'По брендам',
      value: 'ABC_by_brand',
    },
    {
      label: 'Оборачиваемость по товарам',
      value: 'IDC_by_products',
    },
    {
      label: 'Оборачиваемость по группам',
      value: 'IDC_by_groups',
    }
  ],
  [routes.lowHigh]: [
    {
      label: 'По товару',
      value: 'LH_by_products',
    },
    {
      label: 'По категории',
      value: 'LH_by_category',
    },
    {
      label: 'По бренду',
      value: 'LH_by_brands',
    },
  ],
};

const urlMap = {
  [routes.analytics]: 'general',
  [routes.advertising]: 'advertising',
  [routes.ordersAndSales]: 'orders',
  [routes.prices]: 'prices',
  [routes.stock]: 'stock',
  [routes.marginality_analysis]: 'marginality_analysis',
  [routes.returnAndCancellations]: 'returns_cancellations',
  [routes.abc]: 'classification',
  [routes.lowHigh]: 'low-high',
  [routes.slices]: 'slices',
  [routes.brand_report]: 'brand_report'
};

const fbo_fbm_options = [
  {
    label: "FBM",
    value: "fbm"
  },
  {
    label: "FBS",
    value: "fbs"
  }
];

const AnalyticsPage = ({ route, activeSubItems }) => {
  const apiIdRef = useRef();
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());
  const { handleStatusCode, handleRequestError } = useResponseHandler();
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, route);

  const currentPageFilters = pageFiltersMap[route] || {};
  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'brand_lens', type: 'multi' },
    { key: 'campaign', type: 'multi' },
    { key: 'warehouse', type: 'multi' },
    { key: 'product', type: 'multi' },
    { key: 'group_missed_sales', type: 'multi' },
    { key: 'adv_campaign', type: 'multi' },
    { key: 'super_status', type: 'multi' },
    { key: 'adv_campaign_type', type: 'multi' },
    { key: 'adv_status', type: 'multi' },
    { key: 'summary', type: 'multi' },
    { key: 'margin', type: 'multi' },
    { key: 'fbo_fbm', type: 'multi' },
    { key: 'period', type: 'single' },
    // bool
    { key: 'check', type: 'boolean' },
    { key: 'negative_marg', type: 'boolean' },
    { key: 'bad_idc', type: 'boolean' },
    { key: 'in_action', type: 'boolean' },
    { key: 'with_sebestoimost', type: 'boolean' },
    { key: 'delivery_date', type: 'boolean' },
    { key: 'diff_rub', type: 'boolean' },
    { key: 'with_remnants', type: 'boolean' },
    { key: 'in_advertising', type: 'boolean' },
    { key: 'reverse', type: 'boolean' },
    { key: 'stock', type: 'boolean' },
    // date
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];

  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [brandDataLens, setBrandDataLens] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [advCampaignData, setAdvCampaignData] = useState([]);
  const [superStautsData, setSuperStatusData] = useState([]);
  const [advCampaignTypeData, setAdvCampaignTypeData] = useState([]);
  const [advStatusData, setAdvStatusData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [marginData, setMarginData] = useState([]);

  const [selectedMp, setSelectedMp] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrandLens, setSelectedBrandLens] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCampaign, setSelectedCampaign] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [selectedAdvCampaign, setSelectedAdvCampaign] = useState([]);
  const [selectedSuperStauts, setSelectedSuperStatus] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedAdvCampaignType, setSelectedAdvCampaignType] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedAdvStatus, setSelectedAdvStatus] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedSummary, setSelectedSummary] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedMargin, setSelectedMargin] = useState([]);
  const [selectedFboFbm, setSelectedFboFbm] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedPeriod, setSelectedPeriod] = useState({ label: 'По дням', value: 'day' });

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalBrandLens, setTotalBrandLens] = useState(0)
  const [totalCampaign, setTotalCampaign] = useState(0)
  const [totalWarehouse, setTotalWarehouse] = useState(0)
  const [totalAdvCampaign, setTotalAdvCampaign] = useState(0)
  const [totalSuperStauts, setTotalSuperStatus] = useState(0)
  const [totalAdvCampaignType, setTotalAdvCampaignType] = useState(0)
  const [totalAdvStatus, setTotalAdvStatus] = useState(0)
  const [totalSummary, setTotalSummary] = useState(0)
  // const [totalMargin, setTotalMargin] = useState(0)
  const [totalFboFbm, setTotalFboFbm] = useState(0)

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [brandPageLens, setBrandPageLens] = useState(1);
  const [campaignPage, setCampaignPage] = useState(1);
  const [warehousePage, setWarehousePage] = useState(1);
  const [advCampaignPage, setAdvCampaignPage] = useState(1);
  const [superStatusPage, setSuperStatusPage] = useState(1);
  const [advCampaignTypePage, setAdvCampaignTypePage] = useState(1);
  const [advStatusPage, setAdvStatusPage] = useState(1);
  const [summaryPage, setSummaryPage] = useState(1);
  const [marginPage, setMarginPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [brandQueryLens, setBrandQueryLens] = useState('');
  const [campaignQuery, setCampaignQuery] = useState('');
  const [warehouseQuery, setWarehouseQuery] = useState('');
  const [advCampaignQuery, setAdvCampaignQuery] = useState('');
  const [superStatusQuery, setSuperStatusQuery] = useState('');
  const [advCampaignTypeQuery, setAdvCampaignTypeQuery] = useState('');
  const [advStatusQuery, setAdvStatusQuery] = useState('');
  const [summaryQuery, setSummaryQuery] = useState('');
  const [marginQuery, setMarginQuery] = useState('');

  // Чекбоксы
  const [check, setCheck] = useState(false)
  const [isNegativeMarg, setIsNegativeMarg] = useState(false)
  const [isBadIdc, setIsBadIdc] = useState(false)
  const [isInAction, setIsInAction] = useState(false)
  const [isWithSebestoimost, setIsWithSebestoimost] = useState(false)
  const [isDeliveryDate, setIsDeliveryDate] = useState(false)
  const [isDiffRub, setIsDiffRub] = useState(false)
  const [isWithRemnants, setIsWithRemnants] = useState(false)
  const [isInAdvertising, setIsInAdvertising] = useState(false)
  const [isReverse, setIsReverse] = useState(false);
  const [isStock, setIsStock] = useState(false);

  const params = useParams();
  const activeTab = params['*'];

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;
  const [isTableRequest, setIsTableRequest] = useState(false);

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    // Хук подставляет сохранённое в URL: пока isReady false, сбрасываем флаг,
    // чтобы когда isReady снова станет true, URL заново применился к фильтрам
    if (!isReady) {
      setIsInitialLoadFromURL(false);
      return;
    }
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMp(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.brand_lens) setSelectedBrandLens(urlParams.brand_lens)
        if (urlParams.campaign) setSelectedCampaign(urlParams.campaign)
        if (urlParams.warehouse) setSelectedWarehouse(urlParams.brand)
        if (urlParams.adv_campaign) setSelectedAdvCampaign(urlParams.adv_campaign)
        if (urlParams.super_status) setSelectedSuperStatus(urlParams.super_status)
        if (urlParams.summary) setSelectedSummary(urlParams.summary)
        if (urlParams.margin) setSelectedMargin(urlParams.margin)
        if (urlParams.fbo_fbm) setSelectedFboFbm(urlParams.fbo_fbm)
        if (urlParams.period) setSelectedPeriod(urlParams.period)

        // Checkbox
        if (urlParams.check) setCheck(urlParams.check)
        if (urlParams.negative_marg) setIsNegativeMarg(urlParams.negative_marg)
        if (urlParams.bad_idc) setIsBadIdc(urlParams.bad_idc)
        if (urlParams.in_action) setIsInAction(urlParams.in_action)
        if (urlParams.with_sebestoimost) setIsWithSebestoimost(urlParams.with_sebestoimost)
        if (urlParams.delivery_date) setIsDeliveryDate(urlParams.delivery_date)
        if (urlParams.diff_rub) setIsDiffRub(urlParams.diff_rub)
        if (urlParams.with_remnants) setIsWithRemnants(urlParams.with_remnants)
        if (urlParams.in_advertising) setIsInAdvertising(urlParams.in_advertising)
        if (urlParams.reverse) setIsReverse(urlParams.reverse)
        if (urlParams.stock) setIsStock(urlParams.stock)

        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMp,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      brand_lens: urlParams?.brand_lens || selectedBrandLens,
      campaign: urlParams?.campaign || selectedCampaign,
      warehouse: urlParams?.warehouse || selectedWarehouse,
      adv_campaign: urlParams?.adv_campaign || selectedAdvCampaign,
      super_status: urlParams?.super_status || selectedSuperStauts,
      adv_campaign_type: urlParams?.adv_campaign_type || selectedAdvCampaignType,
      adv_status: urlParams?.adv_status || selectedAdvStatus,
      summary: urlParams?.summary || selectedSummary,
      margin: urlParams?.margin || selectedMargin,
      fbo_fbm: urlParams?.fbo_fbm || selectedFboFbm,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
      period: urlParams?.period || selectedPeriod,
      // checkbox
      // check: urlParams?.check || null,
      // negative_marg: urlParams?.negative_marg || null,
      // bad_idc: urlParams?.bad_idc || null,
      // in_action: urlParams?.in_action || null,
      // with_sebestoimost: urlParams?.with_sebestoimost || null,
      // delivery_date: urlParams?.delivery_date || null,
      // diff_rub: urlParams?.diff_rub || null,
      // with_remnants: urlParams?.with_remnants || null,
      // in_advertising: urlParams?.in_advertising || null,
    })
  }, [route, isReady]);

  const cur_selectedBrand = (route === 'brand_report' || route === 'slices') ? selectedBrandLens : selectedBrand

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedCategory,
      selectedBrand: cur_selectedBrand,
      selectedShop: selectedMp,
      filter: 'api_id',
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  useEffect(() => {
    setApiPage(1)
  }, [apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.api) apiFilter();
  }, [apiPage, apiQuery, isFilterRequest]);

  const superStatusFilter = () => {
    const controller = requestControllerRef.current.createController('super-status');

    fetchOrderSuperStatusFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalSuperStatus,
      page: superStatusPage,
      setSuperStatusData: setSuperStatusData,
      searchParam: superStatusQuery,
      selectedCategory,
      selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      selectedCampaign,
      apiData,
      selectedApi,
      dateFrom,
      dateTo,
    })?.finally(() => {
      requestControllerRef.current.removeController('super-status');
    })
  };

  useEffect(() => {
    setSuperStatusPage(1)
  }, [superStatusQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.superStatus) superStatusFilter();
  }, [superStatusPage, superStatusQuery, route, isFilterRequest]);

  const campaignTypeFilter = () => {
    const controller = requestControllerRef.current.createController('adv-campaign-type');

    fetchAdvCampaignTypeFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalAdvCampaign,
      page: advCampaignTypePage,
      setSuperStatusData: setAdvCampaignTypeData,
      searchParam: advCampaignTypeQuery,
      selectedCategory,
      selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      selectedCampaign,
      apiData,
      selectedApi,
      dateFrom,
      dateTo,
      setSelectedFilter: setSelectedAdvCampaignType,
      set: setAdvCampaignTypeData
    })?.finally(() => {
      requestControllerRef.current.removeController('adv-campaign-type');
    })
  };

  useEffect(() => {
    setCampaignPage(1)
  }, [campaignQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.advCampaignType) campaignTypeFilter()
  }, [campaignPage, campaignQuery, route, isFilterRequest]);

  const advStatusFilter = () => {
    const controller = requestControllerRef.current.createController('adv-statuse');

    fetchAdvStatusFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalAdvStatus,
      page: advStatusPage,
      setSuperStatusData: setAdvStatusData,
      searchParam: advStatusQuery,
      selectedCategory,
      selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      selectedCampaign,
      apiData,
      selectedApi,
      dateFrom,
      dateTo,
      set: setAdvStatusData,
      setSelectedFilter: setSelectedAdvStatus
    })?.finally(() => {
      requestControllerRef.current.removeController('adv-statuse');
    })
  };

  useEffect(() => {
    setAdvStatusPage(1)
  }, [advStatusQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.advStatus) advStatusFilter();
  }, [advStatusQuery, advStatusPage, route, isFilterRequest]);

  const advCampaignFilter = (abortController = new AbortController()) => {
    const controller = requestControllerRef.current.createController('adv-campaign');

    fetchAdvCampaignFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCampaign,
      page: advCampaignPage,
      setAdvCampaignData: setAdvCampaignData,
      searchParam: advCampaignQuery,
      selectedCategory,
      selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      selectedCampaign,
      apiData,
      selectedApi,
      set: setAdvCampaignData,
      setSelectedFilter: setSelectedAdvCampaign,
    })?.finally(() => {
      requestControllerRef.current.removeController('adv-campaign');
    })
  };

  useEffect(() => {
    setAdvCampaignPage(1)
  }, [advCampaignQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.advCampaign) advCampaignFilter();
  }, [advCampaignPage, advCampaignQuery, route, isFilterRequest]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      apiData,
      dateFrom,
      dateTo,
      selectedApi,
      // selectedCategory,
      // selectedBrand: cur_selectedBrand,
      selectedShop: selectedMp,
      // selectedCampaign,
      set: setCategoryData,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      filter: 'category',
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  useEffect(() => {
    setCategoryPage(1)
  }, [categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.category) categoryFilter();
  }, [categoryPage, categoryQuery, isFilterRequest]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrand,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      // selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      // selectedCampaign,
      dateFrom,
      dateTo,
      page: brandPage,
      searchParam: brandQuery,
      set: setBrandData,
      setBrandData: (e) => setBrandData(e),
      filter: 'brand',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  const brandFilterLens = () => {
    const controller = requestControllerRef.current.createController('brand-lens');

    fetchApiFilterLens({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrandLens,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand: selectedBrandLens,
      selectedShop: selectedMp,
      selectedCampaign,
      dateFrom,
      dateTo,
      page: brandPageLens,
      searchParam: brandQueryLens,
      set: setBrandDataLens,
      setBrandData: (e) => setBrandDataLens(e),
      filter: 'brand',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand-lens');
    })
  };

  useEffect(() => {
    setBrandPageLens(1)
  }, [brandQueryLens]);

  useEffect(() => {
    setBrandPage(1)
  }, [brandQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (route == 'brand_report' || route === 'slices') {
      if (currentPageFilters.brand2) brandFilterLens();
    }
  }, [brandPageLens, brandQueryLens, route, isFilterRequest]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.brand) brandFilter();
  }, [brandPage, brandQuery, route, isFilterRequest]);

  const campaignFilter = () => {
    const controller = requestControllerRef.current.createController('campaign');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCampaign,
      page: campaignPage,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      selectedCampaign,
      brandData,
      dateFrom,
      dateTo,
      searchParam: campaignQuery,
      set: setCampaignData,
      setCampaignData: (e) => setCampaignData(e),
      filter: 'campaign',
    })?.finally(() => {
      requestControllerRef.current.removeController('campaign');
    })
  };

  useEffect(() => {
    setCampaignPage(1)
  }, [campaignQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.campaign) campaignFilter();
  }, [campaignPage, campaignQuery, route, isFilterRequest]);

  const warehouseFilter = () => {
    const controller = requestControllerRef.current.createController('warehouse');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalWarehouse,
      page: warehousePage,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand: selectedBrand,
      selectedShop: selectedMp,
      selectedCampaign,
      brandData,
      dateFrom,
      dateTo,
      searchParam: warehouseQuery,
      set: setWarehouseData,
      setWarehouseData: (e) => setWarehouseData(e),
      filter: 'warehouse',
    })?.finally(() => {
      requestControllerRef.current.removeController('warehouse');
    })
  };

  useEffect(() => {
    setWarehousePage(1)
  }, [warehouseQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.warehouse) warehouseFilter();
  }, [warehousePage, warehouseQuery, route, isFilterRequest]);

  // Фильтр для LowHigh

  const summaryFilter = () => {
    const controller = requestControllerRef.current.createController('summary');

    fetchApiFilterSummary({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalSummary,
      page: summaryPage,
      searchParam: summaryQuery,
      set: setSummaryData
    })?.finally(() => {
      requestControllerRef.current.removeController('summary');
    })
  };

  useEffect(() => {
    setSummaryPage(1)
  }, [summaryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    if (currentPageFilters.summary) summaryFilter();
  }, [summaryPage, summaryQuery, route, isFilterRequest]);

  // Фильтр для себестоимости
  const marginFilter = () => {
    const controller = requestControllerRef.current.createController('margin');

    fetchCostFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      page: marginPage,
      searchParam: marginQuery,
      set: setMarginData
    })?.finally(() => {
      requestControllerRef.current.removeController('margin');
    })
  };

  useEffect(() => {
    if (route === 'marginality_analysis' && currentPageFilters?.margin) marginFilter()
  }, [route]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    if (marginData?.length) {
      setSelectedMargin(marginData?.[0])
    }
  }, [marginData]);

  useEffect(() => {
    apiIdRef.current?.focus();
  }, []);

  const includeCampaign = Array.isArray(selectedMp)
    ? selectedMp?.some((item) => item.label === 'Все') ||
    selectedMp?.some((item) => item.label === 'Yandex')
    : false;


  const filters = (child = false) => {
    return (
      <FilterContainer
        loading={isSaved}
        saveFilters={saveFilters}
        clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
        onReset={(e) => {
          setSelectedMp([])
          setSelectedApi([]);
          setSelectedCategory([]);
          setSelectedBrand([]);
          setSelectedBrandLens([]);
          setSelectedCampaign([]);
          setSelectedWarehouse([]);
          setAdvCampaignData([]);
          setSelectedAdvCampaign([])
          setSelectedSuperStatus([])
          setSelectedAdvCampaignType([])
          setSelectedAdvStatus([])
          setSelectedSummary([])
          setSelectedMargin([])
          setSelectedFboFbm([])
          updateURL({
            mp: null,
            api: null,
            category: null,
            brand: null,
            brand_lens: null,
            campaign: null,
            warehouse: null,
            product: null,
            group_missed_sales: null,
            adv_campaign: null,
            super_status: null,
            adv_campaign_type: null,
            adv_status: null,
            summary: null,
            margin: null,
            fbo_fbm: null,
          });
          setIsTableRequest(!isTableRequest)
          setIsFilterRequest(!isFilterRequest);
        }}
      >
        {currentPageFilters.mp && <DropDownSelector
          options_prop={options_prop_mp}
          state={selectedMp}
          setState={setSelectedMp}
          placeholder="Площадка"
          total={options_prop_mp?.length}
          onBlur={() => {
            updateURL({ mp: selectedMp });
            apiFilter();
            categoryFilter();
            brandFilter();
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />
        }

        {currentPageFilters.api && <DropDownSelector
          options_prop={apiData}
          state={selectedApi}
          setState={setSelectedApi}
          placeholder="Магазин"
          total={totalApi}
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
          inputRef={true}
          ref={apiIdRef}
          multi
          onBlur={() => {
            updateURL({ api: selectedApi });
            categoryFilter();
            brandFilter();
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
        />
        }

        {currentPageFilters.category && <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          total={totalCategory}
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          multi
          onBlur={() => {
            updateURL({ category: selectedCategory });
            brandFilter();
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
        />
        }

        {currentPageFilters.brand && <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          total={totalBrand}
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          onBlur={(e) => {
            updateURL({ brand: selectedBrand });
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />
        }

        {currentPageFilters.brand2 && <DropDownSelector
          options_prop={brandDataLens}
          state={selectedBrandLens}
          setState={setSelectedBrandLens}
          placeholder="Бренд"
          total={totalBrandLens}
          fetchCallback={setBrandPageLens}
          setInputChange={setBrandQueryLens}
          onBlur={(e) => {
            updateURL({ brand_lens: selectedBrandLens });
            brandFilter();
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />
        }

        {currentPageFilters.campaign && includeCampaign && (
          (route != 'ABCXYZ' && route !== 'low-high' && route !== 'marginality_analysis') && <DropDownSelector
            options_prop={campaignData}
            state={selectedCampaign}
            setState={(e) => setSelectedCampaign(e)}
            placeholder="Кампания"
            total={totalCampaign}
            fetchCallback={(e) => setCampaignPage(e)}
            setInputChange={(e) => setCampaignQuery(e)}
            defaultValue={[{ label: 'Все', value: 'all' }]}
            onBlur={(e) => {
              updateURL({ campaign: selectedCampaign });
              superStatusFilter();
              campaignTypeFilter();
              advStatusFilter();
              advCampaignFilter();
              campaignFilter();
              warehouseFilter();
              setIsTableRequest(!isTableRequest);
            }}
            multi
          />
        )}

        {currentPageFilters.warehouse && <DropDownSelector
          options_prop={warehouseData}
          state={selectedWarehouse}
          setState={setSelectedWarehouse}
          placeholder="Склад"
          total={totalWarehouse}
          fetchCallback={setWarehousePage}
          setInputChange={setWarehouseQuery}
          defaultValue={[{ label: 'Все', value: 'all' }]}
          onBlur={(e) => {
            updateURL({ warehouse: selectedWarehouse });
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />
        }

        {currentPageFilters.advCampaign && <DropDownSelector
          options_prop={advCampaignData}
          state={selectedAdvCampaign}
          setState={(e) => setSelectedAdvCampaign(e)}
          placeholder="Рекламная кампания"
          total={totalAdvCampaign}
          fetchCallback={(e) => setAdvCampaignPage(e)}
          setInputChange={(e) => setAdvCampaignQuery(e)}
          defaultValue={[{ label: 'Все', value: 'all' }]}
          onBlur={(e) => {
            updateURL({ adv_campaign: selectedAdvCampaign });
            if (currentPageFilters.superStatus) superStatusFilter();
            if (currentPageFilters.advCampaignType) campaignTypeFilter();
            if (currentPageFilters.advStatus) advStatusFilter();
            if (currentPageFilters.advCampaign) advCampaignFilter();
            if (currentPageFilters.campaign) campaignFilter();
            if (currentPageFilters.warehouse) warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />
        }

        {currentPageFilters.superStatus && <DropDownSelector
          options_prop={superStautsData}
          state={selectedSuperStauts}
          setState={setSelectedSuperStatus}
          placeholder="Статус заказа"
          total={totalSuperStauts}
          fetchCallback={setSuperStatusPage}
          setInputChange={setSuperStatusQuery}
          onBlur={(e) => {
            updateURL({ super_status: selectedSuperStauts });
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />}

        {currentPageFilters.advCampaignType &&
          <DropDownSelector
            options_prop={advCampaignTypeData}
            state={selectedAdvCampaignType}
            setState={setSelectedAdvCampaignType}
            placeholder="По типу рекламной кампании"
            total={totalAdvCampaignType}
            fetchCallback={setAdvCampaignTypePage}
            setInputChange={setAdvCampaignTypeQuery}
            multi
            onBlur={(e) => {
              updateURL({ adv_campaign_type: selectedAdvCampaignType });
              superStatusFilter();
              campaignTypeFilter();
              advStatusFilter();
              advCampaignFilter();
              campaignFilter();
              warehouseFilter();
              setIsTableRequest(!isTableRequest);
            }}
          />
        }

        {currentPageFilters.advStatus && <DropDownSelector
          options_prop={advStatusData}
          state={selectedAdvStatus}
          setState={setSelectedAdvStatus}
          placeholder="По статусу рекламной кампании"
          total={totalAdvStatus}
          fetchCallback={setAdvStatusPage}
          setInputChange={setAdvStatusQuery}
          multi
          onBlur={(e) => {
            updateURL({ adv_status: selectedAdvStatus });
            superStatusFilter();
            campaignTypeFilter();
            advStatusFilter();
            advCampaignFilter();
            campaignFilter();
            warehouseFilter();
            setIsTableRequest(!isTableRequest);
          }}
        />
        }

        {/* фильтр для low-high */}
        {currentPageFilters.summary && <DropDownSelector
          options_prop={summaryData}
          state={selectedSummary}
          setState={setSelectedSummary}
          placeholder="По сумарным данным"
          total={totalSummary}
          fetchCallback={setSummaryPage}
          setInputChange={setSummaryQuery}
          multi
          onBlur={(e) => {
            updateURL({ summary: selectedSummary });
            setIsTableRequest(!isTableRequest);
          }}
        />
        }

        {/* фильтр для Себестоимости */}
        {currentPageFilters.margin && <DropDownSelector
          className='selector_wrapper__long'
          isClearable={false}
          options_prop={marginData}
          state={selectedMargin}
          setState={setSelectedMargin}
          placeholder="Отношение маржинальности"
          fetchCallback={setMarginPage}
          setInputChange={setMarginQuery}
          width='100%'
          onBlur={(e) => {
            updateURL({ margin: selectedMargin });
            setIsTableRequest(!isTableRequest);
          }}
        />}

        {/* фильтр для Остатков */}
        {currentPageFilters.fbs_fbm &&
          (activeTab === 'product' && <DropDownSelector
            options_prop={fbo_fbm_options}
            total={totalFboFbm}
            state={selectedFboFbm}
            setState={setSelectedFboFbm}
            placeholder="fbo/fbm"
            onBlur={(e) => {
              updateURL({ fbo_fbm: selectedFboFbm });
              setIsTableRequest(!isTableRequest);
            }}
            multi
          />)
        }

        {child}

      </FilterContainer>
    );
  }

  // Элемент даты
  const rangeBox = (
    <RangeBox
      date={date}
      setDate={(e) => {
        const [newDateFrom, newDateTo] = e;
        updateURL({
          date_from: newDateFrom,
          date_to: newDateTo
        });
        setDate(e)
      }}
    />
  );

  return (
    <AnalyticsPageComponent
      activeSubItems={activeSubItems}
      tabs={pageTabsMap[route]}
      relativeUrl={urlMap[route]}
      rangeBox={rangeBox}
      date={date}
      filters={filters}
      selectedMp={selectedMp}
      selectedApi={selectedApi}
      selectedBrand={selectedBrand}
      selectedBrandLens={selectedBrandLens}
      selectedCategory={selectedCategory}
      selectedCampaign={selectedCampaign}
      selectedWarehouse={selectedWarehouse}
      selectedAdvCampaign={selectedAdvCampaign}
      selectedSuperStauts={selectedSuperStauts}
      selectedAdvCampaignType={selectedAdvCampaignType}
      selectedAdvStatus={selectedAdvStatus}
      selectedSummary={selectedSummary}
      selectedMargin={selectedMargin}
      selectedFboFbm={selectedFboFbm}
      route={route}
      setSelectedCategory={setSelectedCategory}
      setSelectedBrand={setSelectedBrand}
      isTableRequest={isTableRequest}
      setIsTableRequest={setIsTableRequest}
      // Чекбоксы
      check={check}
      setCheck={setCheck}
      isNegativeMarg={isNegativeMarg}
      setIsNegativeMarg={setIsNegativeMarg}
      isBadIdc={isBadIdc}
      setIsBadIdc={setIsBadIdc}
      isInAction={isInAction}
      setIsInAction={setIsInAction}
      isWithSebestoimost={isWithSebestoimost}
      setIsWithSebestoimost={setIsWithSebestoimost}
      isDeliveryDate={isDeliveryDate}
      setIsDeliveryDate={setIsDeliveryDate}
      isDiffRub={isDiffRub}
      setIsDiffRub={setIsDiffRub}
      isWithRemnants={isWithRemnants}
      setIsWithRemnants={setIsWithRemnants}
      isInAdvertising={isInAdvertising}
      setIsInAdvertising={setIsInAdvertising}
      isReverse={isReverse}
      setIsReverse={setIsReverse}
      isStock={isStock}
      setIsStock={setIsStock}
      updateURL={updateURL}
      isReady={isReady}
      selectedPeriod={selectedPeriod}
      setSelectedPeriod={setSelectedPeriod}
    />
  );
};

export { AnalyticsPage };
